export default "__VITE_ASSET__CVlSXPCk__"